export default __webpack_public_path__ + "static/media/person icon.146eec1a.svg";